import { cva, VariantProps } from 'class-variance-authority';
import Link from 'next/link';
import React from 'react';

import { cn } from '@/utils/cn';

const textLinkVariants = cva(
  'rounded-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
  {
    variants: {
      variant: {
        /** Inline text link — prose, callouts, "view the docs". */
        default:
          'text-link underline-offset-2 hover:text-link-hover hover:underline',
        /** Table cells and list rows, where the row itself is the affordance
            and coloring every link would read as noise. */
        quiet: 'text-foreground hover:text-foreground/50'
      }
    },
    defaultVariants: {
      variant: 'default'
    }
  }
);

export interface TextLinkProps
  extends React.ComponentPropsWithoutRef<typeof Link>,
    VariantProps<typeof textLinkVariants> {}

const TextLink = React.forwardRef<HTMLAnchorElement, TextLinkProps>(
  function TextLink({ className, variant, ...props }, ref) {
    return (
      <Link
        ref={ref}
        className={cn(textLinkVariants({ variant }), className)}
        {...props}
      />
    );
  }
);

TextLink.displayName = 'TextLink';

export { TextLink, textLinkVariants };
